module.exports = __webpack_public_path__ + "assets/img/patient-title-time.b71cfffa.png";